import { dateToQuarterProps } from 'src/utils/dateToQuarter';

export const quarterlyEndDateToString = (date: dateToQuarterProps | undefined) => {
  return date ? `kwartaal ${date.quarter} van ${date.year}` : '';
};

